import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { persistStore, persistReducer, PersistConfig } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { rootReducer, RootState } from './rootReducer'
import { rootSaga } from './rootSaga'
import { loggerMiddleware, errorHandlerMiddleware } from './middleware'

// Configuração do Redux Persist
const persistConfig: PersistConfig<RootState> = {
  key: 'root',
  storage,
  whitelist: ['auth', 'cart'], // Auth e cart serão persistidos
  blacklist: ['ui'], // UI não precisa ser persistido
}

// Criar middleware do Redux Saga
const sagaMiddleware = createSagaMiddleware()

// Criar reducer persistido
const persistedReducer = persistReducer(persistConfig, rootReducer)

// Configurar store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignorar ações do redux-persist
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    })
      .concat(sagaMiddleware)
      .concat(loggerMiddleware)
      .concat(errorHandlerMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
})

// Criar persistor
export const persistor = persistStore(store)

// Executar root saga
sagaMiddleware.run(rootSaga)

// Tipos para uso em componentes
export type AppDispatch = typeof store.dispatch
export type { RootState }

